import { render, staticRenderFns } from "./AdminPanelYoutvService.vue?vue&type=template&id=1aa36628&"
import script from "./AdminPanelYoutvService.vue?vue&type=script&lang=js&"
export * from "./AdminPanelYoutvService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports